export default __webpack_public_path__ + "static/vedrana-8cb8e7cea38210821e3f392fa279d8b6.jpg";